document.addEventListener("DOMContentLoaded", function() {

  var popup = document.getElementById('video-popup');
  var closePopup = document.getElementById('close-popup');
  var youtubeFrame = document.getElementById('youtube-video');

  // Event delegation for all .youtube-video buttons
  document.addEventListener('click', function(e) {
    var button = e.target.closest('.youtube-video');
    
    if (!button) return;

    var videoUrl = button.getAttribute('data-video-url');
    if (!videoUrl) return;

    // Convert YouTube URL to embed format (supports both youtu.be & watch?v=)
    var videoId = '';

    if (videoUrl.includes('youtu.be/')) {
      videoId = videoUrl.split('youtu.be/')[1];
    } else if (videoUrl.includes('watch?v=')) {
      videoId = videoUrl.split('watch?v=')[1];
    }

    if (videoId) {
      youtubeFrame.src = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
      popup.style.display = 'flex';
    }
  });

  // Close popup
  closePopup.addEventListener('click', function() {
    youtubeFrame.src = "";
    popup.style.display = 'none';
  });

});
